import React from "react";
import { Redirect, useParams } from "react-router-dom";

import { LoadingSpinner } from "@/design-system/components/LoadingSpinner/LoadingSpinner";
import useFeatureFlags from "@/hooks/useFeatureFlag";
import { isWtm2Enabled } from "./isWtm2Enabled";
import useFetchUnifiedWtmReport from "./queries/useFetchUnifiedWtmReport";

function Wtm2TrackerDetailsPageRedirect({ trackerId }: { trackerId: string }) {
  const { data, isLoading } = useFetchUnifiedWtmReport();
  if (isLoading) {
    return <LoadingSpinner />;
  }

  const trackerName = decodeURIComponent(trackerId);
  const tracker = data?.rows.find(
    (row) =>
      row.trackerName === trackerName ||
      row.domains.includes(trackerName) ||
      row.domain === trackerName,
  );
  const destination = tracker
    ? `/monitoring/trackingTools/${encodeURIComponent(tracker.domain)}`
    : "/monitoring/trackingTools";

  return <Redirect to={destination} />;
}

export function WebTrackerDetailsPageRedirect() {
  const { trackerId } = useParams<{ trackerId: string }>();
  const flag = useFeatureFlags();

  if (isWtm2Enabled(flag)) {
    return <Wtm2TrackerDetailsPageRedirect trackerId={trackerId} />;
  }

  return <Redirect to={`/monitoring/trackingTools/${trackerId}`} />;
}
